import {useEffect} from 'react';

import {useNavigate, useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    TabbedComponent,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useApplicationProduct} from '../hooks/useApplicationProduct.ts';
import {useApplicationProductsSelection} from '../hooks/useApplicationProductsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {IndexPage as UsersPage} from "../../users/pages/IndexPage.tsx";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";

export const EditPage = () => {

    const navigate = useNavigate();
    const {allowedActions} = useVerifiedPermissions()

    const {
        id: applicationId,
        applicationProductId,
    } = useParams();

    if (typeof applicationId === 'undefined') {
        throw new Error('applicationId is required parameter');
    }

    if (typeof applicationProductId === 'undefined') {
        throw new Error('applicationProductId is required parameter');
    }

    const {
        record: account,
        updateRecord,
    } = useApplicationProduct(applicationId, applicationProductId);

    const {handleClearSelection} = useApplicationProductsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);


    if (!account) {
        return <PlatformLoader message='Loading application service plan...Please wait'/>;
    }

    const tabs = []
    if (allowedActions.includes(rbacActions.ListUsers)) {
        tabs.push({
                      title: 'Users',
                      component: <UsersPage/>
                  })
    }

    return (
        <FormPageLayout
            title={account.name ? account.name : account.id}
            pageNavigation={<EditPageNavigation component={account}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={account}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <TabbedComponent tabs={tabs}/>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={account}
                    handleSubmit={updateRecord}
                    handleCancel={() => navigate(`/applications/${applicationId}`)}
                />}


        </FormPageLayout>
    );
};
